import { render, staticRenderFns } from "./NewMap.vue?vue&type=template&id=31f81306&"
import script from "./NewMap.vue?vue&type=script&lang=js&"
export * from "./NewMap.vue?vue&type=script&lang=js&"
import style0 from "./NewMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports